export default {
  data() {
    return {
      pdfUrl: null,
    };
  },
  computed: {
    isMobile() {
      // Production-grade mobile detection
      return (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        ) || window.innerWidth <= 768
      );
    },
  },
  methods: {
    /**
     * Converts base64 to Blob URL - more efficient for iframes
     */
    generatePdfUrl(base64Data) {
      if (!base64Data) return;

      // Revoke old URL if it exists
      if (this.pdfUrl) {
        URL.revokeObjectURL(this.pdfUrl);
      }

      try {
        const binaryString = atob(base64Data);
        const bytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        const blob = new Blob([bytes], { type: "application/pdf" });
        this.pdfUrl = URL.createObjectURL(blob);
      } catch (e) {
        console.error("Error generating PDF URL:", e);
        this.pdfUrl = null;
      }
    },

    /**
     * Opens PDF in a new tab - most reliable for mobile devices
     */
    openPdfInNewTab() {
      if (!this.pdfUrl) return;
      window.open(this.pdfUrl, "_blank");
    },
  },
  beforeDestroy() {
    if (this.pdfUrl) {
      URL.revokeObjectURL(this.pdfUrl);
    }
  },
};
